const KEY = 'reano_toast';

export function queueToast(message, type = 'error') {
  sessionStorage.setItem(KEY, JSON.stringify({ message, type }));
}

export function consumeToast() {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  sessionStorage.removeItem(KEY);
  try { return JSON.parse(raw); } catch { return null; }
}
